import styled, { css } from 'styled-components';
import { getFontStyle, rem } from '../../utils';
const TAB_INDICATOR_HEIGHT = 2;
export const StyledWrapper = styled.div `
  display: flex;
  width: 100%;
  flex-direction: column;
`;
export const StyledLabelsWrapper = styled.div `
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: stretch;
  align-content: stretch;
  width: 100%;

  ${({ variant, theme }) => css `
    margin-bottom: ${rem(theme.Components.Tabs.Margin.Bottom)};
    gap: ${variant === 'filled' && rem(theme.Spacing.Size.Small)};
  `}
`;
export const StyledLabelDefault = css `
  ${({ theme }) => css `
    padding-bottom: ${rem(theme.Spacing.Size.XXSmall)};
    color: ${theme.Color.Neutrals.Dark};
  `}

  &:after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    border-radius: 20px;
    transition: opacity ${({ theme }) => theme.Transition.Timing.Out};

    ${({ theme, isActive }) => css `
      height: ${isActive
    ? rem(TAB_INDICATOR_HEIGHT)
    : rem(theme.Components.Tabs.Inactive.BorderSize)};
      background: ${isActive
    ? theme.Color.Brand.Primary
    : theme.Color.Neutrals.Border};
    `}
  }
`;
export const StyledLabelFilledActive = css `
  ${({ theme }) => css `
    background: ${theme.Color.Neutrals.Light};
    color: ${theme.Color.Neutrals.Dark};
  `}

  &:hover,
  &:active {
    color: ${({ theme }) => theme.Color.Brand.Primary};
  }
`;
export const StyledLabelFilledInActive = css `
  background: transparent;
  color: ${({ theme }) => theme.Color.Neutrals.Dark};

  &:hover,
  &:active {
    background: ${({ theme }) => theme.Color.Neutrals.Light};
    color: ${({ theme }) => theme.Color.Brand.Primary};
  }
`;
export const StyledLabelFilled = css `
  ${({ theme }) => css `
    border-radius: ${rem(theme.Border.Radius.Medium)};
    border: 1px solid transparent;
    min-height: ${rem(theme.Spacing.Size.Large)};
    padding: ${`${rem(theme.Spacing.Size.XSmall)} ${rem(theme.Spacing.Size.Small)}`};
  `}

  ${({ isActive }) => isActive ? StyledLabelFilledActive : StyledLabelFilledInActive}
`;
export const StyledLabel = styled.div `
  position: relative;
  display: flex;
  flex: 1;
  cursor: pointer;
  justify-content: center;
  text-align: center;
  align-items: center;
  user-select: none;
  box-sizing: border-box;
  ${getFontStyle('Body')}
  transition: all ${({ theme }) => theme.Transition.Timing.Out};

  &:hover,
  &:active {
    transition: all ${({ theme }) => theme.Transition.Timing.In};
  }

  ${({ variant }) => {
    switch (variant) {
        case 'filled':
            return StyledLabelFilled;
        default:
            return StyledLabelDefault;
    }
}}
`;
export const StyledContentWrapper = styled.section `
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: stretch;
  align-content: stretch;
`;
export const StyledContent = styled.div `
  position: relative;
  display: flex;
  width: 0;
  height: 0;
  overflow: hidden;
  transition: opacity ${({ theme }) => theme.Transition.Timing.Out};

  ${({ isActive }) => isActive
    ? `
        flex: 1;
        visibility: visible;
        width: inherit;
        height: inherit;
        opacity: 1;
      `
    : `
        visibility: hidden;
        opacity: 0;
      `};
`;
//# sourceMappingURL=Tabs.style.js.map